(function () {
  var redirectMap = {
    'parenting-guides': '/pages/blogs?tab=parenting-guides',
    'baby-gear': '/pages/blogs?tab=baby-gear',
    'travel': '/pages/blogs?tab=travel',
    'baby-care': '/pages/blogs?tab=baby-care'
  };

  var handle = document.documentElement.dataset.blogHandle;
  var destination = redirectMap[handle];

  if (destination) {
    window.location.replace(destination);
  }
})();
